import * as React from 'react';
import { NextJsLogoIcon } from 'src/icons/nextjs-logo-icon';
import { NodeJsLogoIcon } from 'src/icons/nodejs-logo-icon';
import { PythonLogoIcon } from 'src/icons/python-logo-icon';
import { ReactLogoIcon } from 'src/icons/react-logo-icon';
import { RemixLogoIcon } from 'src/icons/remix-logo-icon';
import { RubyLogoIcon } from 'src/icons/ruby-logo-icon';

export interface StackOption {
  title: string;
  description: string;
  href: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
}

export const AUTHKIT_STACK_OPTIONS: StackOption[] = [
  {
    title: 'Next.js',
    description: 'For applications that use Next.js for frontend and backend',
    href: '/authkit/nextjs',
    icon: NextJsLogoIcon,
  },
  {
    title: 'Remix',
    description: 'For applications that use Remix for frontend and backend',
    href: '/authkit/remix',
    icon: RemixLogoIcon,
  },
  {
    title: 'Node.js',
    description: 'For applications with a Node.js backend',
    href: '/authkit/vanilla/nodejs',
    icon: NodeJsLogoIcon,
  },
  {
    title: 'Ruby',
    description: 'For applications with a Ruby backend',
    href: '/authkit/vanilla/ruby',
    icon: RubyLogoIcon,
  },
  {
    title: 'Python',
    description: 'For applications with a Python backend',
    href: '/authkit/vanilla/python',
    icon: PythonLogoIcon,
  },
  {
    title: 'React',
    description: 'For client-side, single-page applications',
    href: '/authkit/client-only',
    icon: ReactLogoIcon,
  },
];
